import React from 'react'
import {
    Route,
    Switch,
    Redirect,
} from 'react-router-dom'
import CitiesApp from '../front/components/app/cities'
const EventsFrontList = React.lazy(() => import('../front/components/events/list/container'))
const Groups = React.lazy(() => import('../front/components/groups/list/container'))
const GroupDetail = React.lazy(() => import('../front/components/groups/detail/container'))
const EventDetail = React.lazy(() => import('../front/components/events/detail/container'))
const SportFacilities = React.lazy(() => import('../front/components/sportvenues/list/container'))
const SportFacilityDetail = React.lazy(() => import('../front/components/sportvenues/detail'))
const SportFacilityDetailContacts = React.lazy(() => import('../front/components/sportvenues/detail/contacts'))
const SportFacilityDetailEvents = React.lazy(() => import('../front/components/sportvenues/detail/events'))
const TermsAndConditions = React.lazy(() => import('../components/terms'))
const Organizers = React.lazy(() => import('../components/landing/landing-cities/organizers'))
const AboutProject = React.lazy(() => import('../components/landing/landing-cities/project'))
const TakeInfo = React.lazy(() => import('../components/landing/landing-cities/take-info'))
const Landing = React.lazy(() => import('../components/landing/landing-cities/index'))
const News = React.lazy(() => import('../components/news'))
const NewsDetail = React.lazy(() => import('../components/news/detail'))
import {
    forFeature,
    withRouter,
} from '../validator'
import Configurator from '../configurator'
import NotFoundRoute from './shared/not-found-route'
import UnloggedRoute from './shared/unlogged-route'
import { LoggedRoute } from './shared/logged-route'
const EventsSignpost = React.lazy(() => import('../front/components/signpost/events'))
const GroupsSignpost = React.lazy(() => import('../front/components/signpost/groups'))
const ForChildrenSignpost = React.lazy(() => import('../front/components/signpost/for-children'))
const ForAthletesSignpost = React.lazy(() => import('../front/components/signpost/want-sport'))
const NotificationsIndex = React.lazy(() => import('../components/notifications/index'))
const Entities = React.lazy(() => import('../front/components/entities'))
const LoginSignpost = React.lazy(() => import('../components/auth/login-signpost'))
const LoginForms = React.lazy(() => import('../components/auth/login-forms'))
const SignupForms = React.lazy(() => import('../components/auth/signup-forms'))
const ForgottenPasswordForms = React.lazy(() => import('../components/auth/forgotten-password-forms'))
const CognitoCallback = React.lazy(() => import('../components/auth/cognito-callback'))
const InfoPage = React.lazy(() => import('../components/info-page'))
const Messenger = React.lazy(() => import('../components/messenger'))
import FrontApp from '../front/components/app'
const InvestmentsContainer = React.lazy(() => import('../front/components/investments/list/container'))

@forFeature('CITIES_ROUTES')
@withRouter()
export default class CSTranslatedRoutes extends Configurator {
    render() {
        return (
            <React.Suspense fallback={<span />}>
                <Switch>
                    <Route exact path="/" render={() => <CitiesApp><Landing {...this.props} /></CitiesApp>} />

                    <Redirect exact from="/login" to={this.config.loginRoute} />
                    <Redirect exact from="/signup" to={this.config.signupRoute} />
                    <Redirect exact from="/forgotten-password" to={this.config.forgottenPasswordRoute} />
                    <Redirect exact from="/login-signpost" to={this.config.signpostLoginRoute} />

                    <UnloggedRoute exact path={this.config.signpostLoginRoute} render={() => <LoginSignpost {...this.props} />} />
                    <UnloggedRoute exact path={this.config.loginRoute} render={() => <LoginForms {...this.props} />} />
                    <UnloggedRoute exact path={this.config.signupRoute} render={() => <SignupForms {...this.props} />} />
                    <UnloggedRoute exact path={this.config.forgottenPasswordRoute} render={() => <ForgottenPasswordForms {...this.props} />} />

                    <Route exact path="/cognito/oauth/callback" render={() => <CognitoCallback {...this.props} />} />

                    {/** @TODO - make component more smart and remove this redirects */}
                    <Redirect exact from="/events" to="/udalosti" />
                    <Redirect exact from="/events/:eventSlug" to="/udalosti/:eventSlug" />
                    <Redirect exact from="/events/:eventSlug/:action" to="/udalosti/:eventSlug/:action" />
                    <Redirect exact from="/events/:eventSlug/:action/:type" to="/udalosti/:eventSlug/:action/:type" />

                    <Route
                        exact
                        path="/udalosti"
                        render={() => (
                            <CitiesApp whitelistedFilterRoute footerClass="d-none">
                                <EventsFrontList
                                    {...this.props}
                                    eventFilters={['InterestsEventLinks', 'Name', 'Date|dateButtons', 'Sport', 'Type', 'Me', 'CityPart']}
                                />
                            </CitiesApp>
                        )}
                    />
                    <Route exact path="/udalosti/:eventSlug" render={() => <CitiesApp><EventDetail {...this.props} /></CitiesApp>} />
                    <Route exact path="/udalosti/:eventSlug/:action" render={() => <CitiesApp><EventDetail {...this.props} /></CitiesApp>} />
                    <Route exact path="/udalosti/:eventSlug/:action/:type" render={() => <CitiesApp><EventDetail {...this.props} /></CitiesApp>} />

                    {/** @TODO - make component more smart and remove this redirects */}
                    <Redirect exact from="/clubs" to="/kluby" />
                    <Redirect exact from="/clubs/:clubId" to="/kluby/:clubId" />
                    <Redirect exact from="/clubs/:clubId/:action" to="/kluby/:clubId/:action" />
                    <Redirect exact from="/clubs/:clubId/:action/:type" to="/kluby/:clubId/:action/:type" />

                    <Route
                        exact
                        path="/kluby"
                        render={() => (
                            <CitiesApp whitelistedFilterRoute footerClass="d-none">
                                <Groups
                                    {...this.props}
                                    groupFilters={['InterestsGroupLinks', 'Name', 'Sport', 'Me', 'CityPart']}
                                    defaultLoad={true}
                                />
                            </CitiesApp>
                        )}
                    />
                    <Route exact path="/kluby/:clubId" render={() => <CitiesApp><GroupDetail {...this.props} /></CitiesApp>} />
                    <Route exact path="/kluby/:clubId/:action" render={() => <CitiesApp><GroupDetail {...this.props} /></CitiesApp>} />
                    <Route exact path="/kluby/:clubId/:action/:type" render={() => <CitiesApp><GroupDetail {...this.props} /></CitiesApp>} />


                    {/** @TODO - make component more smart and remove this redirects */}
                    <Redirect exact from="/sport-venues" to="/sportoviste" />
                    <Redirect exact from="/sport-venues/:sportVenueSlug" to="/sportoviste/:sportVenueSlug" />
                    <Redirect exact from="/sport-venues/:sportVenueSlug/:action" to="/sportoviste/:sportVenueSlug/:action" />
                    <Redirect exact from="/sport-venues/:sportVenueSlug/:action/:type" to="/sportoviste/:sportVenueSlug/:action/:type" />

                    <Route
                        exact
                        path="/sportoviste"
                        render={() => (
                            <CitiesApp whitelistedFilterRoute footerClass="d-none">
                                <SportFacilities
                                    {...this.props}
                                    sportvenueFilters={['Name', 'Sport', 'CityPart', 'SportVenueFacility', 'SportVenueEquipment']}
                                    defaultLoad={true}
                                />
                            </CitiesApp>
                        )}
                    />
                    <Route exact path="/sportoviste/:sportVenueSlug" render={() => <CitiesApp><SportFacilityDetail {...this.props} /></CitiesApp>} />
                    <Route exact path="/sportoviste/:sportVenueSlug/contacts" render={() => <CitiesApp><SportFacilityDetailContacts {...this.props} /></CitiesApp>} />
                    <Route exact path="/sportoviste/:sportVenueSlug/events" render={() => <CitiesApp><SportFacilityDetailEvents {...this.props} /></CitiesApp>} />

                    {/*<Route path=":sportFacilityId" component={SportFacilityDetail}/>*/}
                    {/*<Route path=":sportFacilityId/kontakty" component={SportFacilityDetailContacts} />*/}
                    {/*<Route path=":sportFacilityId/udalosti" component={SportFacilityDetailEvents} />*/}

                    <Route exact path="/o-projektu" render={() => <CitiesApp><AboutProject {...this.props} /></CitiesApp>} />
                    <Route exact path="/podminky-pouziti" render={() => <CitiesApp><TermsAndConditions {...this.props} /></CitiesApp>} />

                    {/*<Route exact path="/dotacni-programy-pro-kluby" render={() => <CitiesApp><GrantProgram2018 {...this.props} /></CitiesApp>} />*/}

                    <Route
                        exact
                        path="/investice"
                        render={() => (
                            <CitiesApp whitelistedFilterRoute>
                                <InvestmentsContainer
                                    {...this.props}
                                    filters={
                                        [
                                            'HashTags',
                                            'Sport',
                                            'CityPart',
                                        ]}
                                    initLoad
                                />
                            </CitiesApp>
                        )}
                    />

                    <Route exact path="/jsem-organizator" render={() => <CitiesApp><Organizers {...this.props} /></CitiesApp>} />

                    <Route exact path="/chci-byt-informovan" render={() => <CitiesApp><TakeInfo {...this.props} /></CitiesApp>} />

                    <Route exact path="/pro-sportujici" render={() => <CitiesApp><ForAthletesSignpost {...this.props} /></CitiesApp>} />

                    <Route
                        exact
                        path="/pro-sportujici/udalosti"
                        render={() =>
                            <CitiesApp>
                                <EventsSignpost
                                    filters={['InterestsEventLinks', 'Date|dateButtons', 'Sport', 'Type', 'Me', 'CityPart', 'Gender', 'AthletesLevel']}
                                    defaultTag="4"
                                />
                            </CitiesApp>
                        }
                    />

                    <Route
                        exact
                        path="/pro-sportujici/kluby"
                        render={() =>
                            <CitiesApp>
                                <GroupsSignpost
                                    filters={['InterestsGroupLinks', 'Sport', 'Me', 'CityPart', 'Gender']}
                                    defaultTag="forAthletes=true"
                                />
                            </CitiesApp>
                        }
                    />

                    <Route
                        exact
                        path="/top-udalosti"
                        render={() =>
                            <CitiesApp>
                                <EventsSignpost
                                    filters={['Signpost', 'Date|dateButtons', 'Sport', 'Type', 'Me', 'CityPart']}
                                    defaultTag="1"
                                />
                            </CitiesApp>
                        }
                    />

                    <Route
                        exact
                        path="/top-udalosti/udalosti"
                        render={() =>
                            <CitiesApp>
                                <EventsSignpost
                                    filters={['InterestsEventLinks', 'Date|dateButtons', 'Sport', 'Type', 'Me', 'CityPart']}
                                    defaultTag="1"
                                />
                            </CitiesApp>
                        }
                    />

                    <Route exact path="/pro-deti" render={() => <CitiesApp><ForChildrenSignpost {...this.props} /></CitiesApp>} />

                    <Route
                        exact
                        path="/pro-deti/udalosti"
                        render={() =>
                            <CitiesApp>
                                <EventsSignpost
                                    filters={['InterestsEventLinks', 'Date|dateButtons', 'Sport', 'Type', 'Me', 'CityPart', 'Age']}
                                    defaultTag="2"
                                />
                            </CitiesApp>
                        }
                    />

                    <Route
                        exact
                        path="/pro-deti/kluby"
                        render={() =>
                            <CitiesApp>
                                <GroupsSignpost
                                    filters={['InterestsGroupLinks', 'Sport', 'Me', 'CityPart', 'Age', 'Gender']}
                                    defaultTag="forKids=true"
                                />
                            </CitiesApp>
                        }
                    />

                    <Route
                        exact
                        path="/pro-divaky"
                        render={() =>
                            <CitiesApp>
                                <EventsSignpost
                                    filters={['Signpost', 'Date|dateButtons', 'Sport', 'Type', 'Me', 'CityPart']}
                                    defaultTag="3"
                                />
                            </CitiesApp>
                        }
                    />

                    <Route
                        exact
                        path="/pro-divaky/udalosti"
                        render={() =>
                            <CitiesApp>
                                <EventsSignpost
                                    filters={['InterestsEventLinks', 'Date|dateButtons', 'Sport', 'Type', 'Me', 'CityPart']}
                                    defaultTag="3"
                                />
                            </CitiesApp>
                        }
                    />

                    <Route exact path="/kontakt" render={() => <CitiesApp><InfoPage {...this.props} /></CitiesApp>} />

                    <Route exact path="/aktuality" render={() => <CitiesApp><News {...this.props} /></CitiesApp>} />
                    <Route exact path="/aktuality/:actuality" render={() => <CitiesApp><NewsDetail hideTitle {...this.props} /></CitiesApp>} />

                    {/** @TODO - make component more smart and remove this redirects */}
                    <Redirect exact from="/notifications" to="/upozorneni" />
                    <LoggedRoute exact path="/upozorneni" render={() => <CitiesApp><NotificationsIndex {...this.props} /></CitiesApp>} />
                    <Route exact path={`/${this.config.REACT_APP_TRANSLATION_ROUTES.entities}`} render={() => <CitiesApp><Entities {...this.props} /></CitiesApp>} />

                    <Redirect exact from="/messages" to="/chat" />
                    <Redirect exact from="/messages/t/:threadSlug" to="/chat/t/:threadSlug" />

                    <LoggedRoute exact path="/chat" render={() => <FrontApp showNavAndFooter={true} footerClass="footer--chat"><Messenger {...this.props} /></FrontApp>} />
                    <LoggedRoute exact path="/chat/t/:threadSlug" render={() => <FrontApp showNavAndFooter={true} footerClass="footer--chat"><Messenger {...this.props} /></FrontApp>} />

                    <NotFoundRoute routesType="translatedRoutes" />
                </Switch>
            </React.Suspense>
        )
    }
}
